import { ChangeDetectorRef, Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
declare let startSpeakingButton:any;
declare let innerHTML:any;
@Component({
  selector: 'app-drag-dialog',
  templateUrl: './drag-dialog.component.html',
  styleUrls: ['./drag-dialog.component.css']
})
export class DragDialogComponent implements OnInit {
  @ViewChild('dragParent') dragParent! : ElementRef
  public dialogRef! : MatDialogRef<DragDialogComponent>
  dialogContent:any=[];
  interval:any;
  emitContent = new EventEmitter()
  constructor(@Inject(MAT_DIALOG_DATA) public data : any, private cdr: ChangeDetectorRef) {
      this.dialogContent = data.content;
    setTimeout(() => {
      const obj = document.getElementById('drag-drop-field') as HTMLTextAreaElement | null;
      if (obj) obj.scrollTop = obj.scrollHeight;
    }, 0);
 
   }
  ngOnInit(): void {
 
  }
 
  ngAfterViewInit(){
      document.getElementById('minimize-btn')!.addEventListener('click',() => this.doClose())
  }
 
  getFieldContent(e : any){
    this.dialogContent = e.target.value
  }
 
  doClose(){
    clearInterval(this.interval);
    this.emitContent.emit(this.dialogContent)
  }
   // Exposed method to allow parent to push live updates without closing dialog
  setContent(newContent: string) {
    this.dialogContent = newContent;
    this.cdr.detectChanges();
    setTimeout(() => {
      const obj = document.getElementById('drag-drop-field') as HTMLTextAreaElement | null;
      if (obj) obj.scrollTop = obj.scrollHeight;
    }, 0);
  }
 
}
